function gethttp(url,data,method="post"){
	 // url="http://www.openok.cn/"+endstr+url
	  url="http://www.hbrlzy.org.cn/"+url 
	  // url="http://43.138.102.132/"+url
	 //url="https://quiz.xindongguoji.com"+url
	 let promise=new Promise((reslove,reject)=>{
		if(method=="post"){
		this.$axios.post(url,data).then(res=>{
			reslove(res);
		}).catch(error=>{
			reject(error);
			console.warn(error)
		})
		}
		else if(method=="get"){
		this.$axios.get(url,{params:data}).then(res=>{
			reslove(res);
		}).catch(error=>{
			reject(error);
			console.warn(error)
		})
		}
	 })
	 return promise
}
module.exports={
	gethttp
}


//////////////////
// WEBPACK FOOTER
// ./static/js/Gethttp.js
// module id = 4A+t
// module chunks = 1